import { Flex, Form } from "antd";
import { styled } from "styled-components";

export const StyledAppVerifyCodeForm = styled(Form)`
  width: 100%;
  .ant-form-item {
    margin-bottom: 16px;
  }
  .ant-input,
  .ant-input-affix-wrapper {
    padding: 16px;
  }
  .ant-otp {
    display: flex !important;
  }
`;

export const StyledAppVerifyFlex = styled(Flex)`
  width: 100%;
`;
